export enum MenteesPlanStatus {
    Initiated = 'INITIATED',
    Processing = 'PROCESSING',
    Failed = 'FAILED',
    Active = 'ACTIVE',
    InActive = 'IN_ACTIVE',
    Expired = 'EXPIRED',
}
